var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text',{ref:"svg_text",attrs:{"x":_vm.x,"y":_vm.y,"fill":_vm.getColorWarningHipScore(_vm.actualScore)}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }